import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import SelectSiteListModal from "../../SelectSiteListModal";
import SelectProductModal from "../../SelectProductModal";
import pick from 'lodash.pick';
import { getAction, httpAction } from '@api/manage';
import moment from 'moment';
import { accMul } from '@/utils/util.js';
export default {
  name: 'StockLogModal',
  components: {
    SelectSiteListModal: SelectSiteListModal,
    SelectProductModal: SelectProductModal
  },
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: '出入库记录表单',
      tableName: 'ea_stock_log',
      form_fields: ['siteId', 'category', 'supplierId', 'productId', 'amount', 'price', 'worth', 'remark'],
      form_fields_time: ['dtime'],
      validatorRules: {
        siteId: {
          rules: [{
            required: true,
            message: '请输入出库站点ID!'
          }]
        },
        dtime: {
          rules: [{
            required: true,
            message: '请输入时间!'
          }]
        },
        category: {
          rules: [{
            required: true,
            message: '请输入出入库类型!'
          }]
        },
        productId: {
          rules: [{
            required: true,
            message: '请输入产品ID!'
          }]
        },
        amount: {
          rules: [{
            required: true,
            message: '请输入产品数量!'
          }]
        }
      },
      companyList: [],
      selectedSite: [],
      selectedProduct: [],
      siteIds: [],
      productIds: [],
      disableSubmitProduct: false,
      buttonStatus: false,
      url: {
        add: '/stock/log',
        queryCompany: '/ea/company/info/queryCompanyName'
      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {
    moment: moment,
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.loadCompany();
      this.selectedSite = [];
      this.siteCategoryList = [];
      this.selectedSite = [];
      this.selectedProduct = [];
      this.siteIds = [];
      this.productIds = [];
      this.model.dtime = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');

      if (this.model.productId == null) {
        this.model.category = 1;
        this.disableSubmitProduct = false;
      } else {
        this.model.category = 2;
        this.productIds = this.model.productId;
        this.selectedProduct = this.model.name;
        this.model.worth = this.model.sumWorth;
        this.model.amount = this.model.sumAmount; // this.model.price = accDiv(this.model.sumWorth, this.model.sumAmount)

        this.disableSubmitProduct = true;
      }

      this.$nextTick(function () {
        var that = _this;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item], 'YYYY-MM-DD HH:mm:ss') : null;
        });
        that.form.setFieldsValue(timeVal);
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      if (this.model.sumAmount < this.form.getFieldValue('amount')) {
        this.$message.error('出库数量大于库存数量!', 2);
      } else {
        var that = this; // 触发表单验证

        this.form.validateFields(function (err, values) {
          if (!err) {
            that.confirmLoading = true;
            var formData = Object.assign(that.model, values); // 入库时间

            formData.dtime = formData.dtime ? formData.dtime.format('YYYY-MM-DD HH:mm:ss') : null; // formData.siteId = that.siteIds

            formData.siteId = that.siteIds == [] || that.siteIds.length == 0 ? null : that.siteIds;
            formData.productId = that.productIds == [] || that.productIds.length == 0 ? null : that.productIds;
            var httpurl = '',
                method = '';

            if (!_this2.model.id) {
              httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
              method = 'post';
            } else {
              httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
              method = 'put';
            }

            httpAction(httpurl, formData, method).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.$emit('ok');
                that.close();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            }).finally(function () {
              that.confirmLoading = false;
            });
          }
        });
      }
    },
    loadCompany: function loadCompany() {
      var that = this;
      that.companyList = [];
      getAction(this.url.queryCompany).then(function (res) {
        if (res.success) {
          that.companyList = res.result;
        }
      });
    },
    total: function total() {
      if (this.model.sumAmount < this.form.getFieldValue('amount')) {
        this.$message.error('出库数量大于库存数量!', 2);
      }

      var amount = this.form.getFieldValue('amount');
      var price = this.form.getFieldValue('price');

      if (amount != null && price != null) {
        this.form.setFieldsValue(_defineProperty({}, 'worth', accMul(amount, price)));
      } // if (amount != null && price != null && this.model.productId == null) {
      //   debugger
      //   this.form.setFieldsValue({ ['worth']: accMul(amount, price) })
      // } else if (amount != null && price != null && this.model.productId != null) {
      //   debugger
      //   let balance = this.model.sumAmount - this.form.getFieldValue('amount')
      //   this.form.setFieldsValue({ ['worth']: accMul(balance, price) })
      // }

    },
    // 子modal回调
    choseSite: function choseSite(siteList) {
      this.selectedSite = [];
      this.siteIds = [];
      this.form.setFieldsValue({
        siteCategoryId: null
      });
      this.siteCategoryList = [];

      for (var i = 0; i < siteList.length; i++) {
        this.selectedSite.push(siteList[i].name);
        this.siteIds = siteList[i].id;
      }
    },
    selectSite: function selectSite() {
      this.$refs.SiteListModal.add(this.selectedSite, this.siteIds);
    },
    selectProducts: function selectProducts() {
      this.$refs.ProductListModal.category = this.productCategory;
      this.$refs.ProductListModal.disableSubmit = true;
      this.$refs.ProductListModal.add(this.selectedProduct, this.productIds);
    },
    // 子modal回调
    choseProduct: function choseProduct(productList) {
      this.selectedProduct = [];
      this.productIds = [];

      for (var i = 0; i < productList.length; i++) {
        this.selectedProduct.push(productList[i].name);
        this.productIds = productList[i].id;
      }
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};